import { render, staticRenderFns } from "./ItemActions.vue?vue&type=template&id=8e72ff2c&scoped=true"
import script from "./ItemActions.vue?vue&type=script&lang=js"
export * from "./ItemActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e72ff2c",
  null
  
)

export default component.exports